import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveGlobalConfig, updateDateFormat } from '../../FilterActions';
import { CustomSelect } from '../common';

class DateFormat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        { label: 'DD MMM YYYY', value: 'DD MMM YYYY' },
        { label: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
        { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
        { label: 'MMM DD, YYYY', value: 'MMM DD, YYYY' },
        { label: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
        { label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
        { label: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
        { label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selected) {
    this.props.updateValue(selected);
    this.props.saveConfig();
  }

  render() {
    const { items } = this.state;

    return (
      <CustomSelect
        name={'dateFormat'}
        title={'Date format'}
        items={items}
        value={this.props.value}
        onSelect={this.handleChange}
      />
    );
  }
}

DateFormat.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveGlobalConfig()),
    updateValue: (val) => dispatch(updateDateFormat(val)),
  };
};

const mapStateToProps = (state) => {
  return {
    value: state.filters.dateFormat,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(DateFormat);
export { connected as DateFormat };
